module.exports = "/images/arrow-down.svg?d5061e376ecaceb6005ad24cded5ce72";